import { ls, t } from '../i18n';
/** Оформление хука на главном экране: горизонтальная лента карточек из макета. */
import type { ReactElement } from 'react';
import { HOOK_STYLE_CHOICES, HOOK_STYLE_LABELS, type HookAccent, type HookDesign } from '@reels/shared/constants';
import * as telegram from '../lib/telegram';
import { HookOverlay } from './HookOverlay';


export function HookStyleCarousel({ value, onChange, accent, accentMode, fontFamily, box }: {
  value: HookDesign;
  onChange: (style: HookDesign) => void;
  /** Цвет подсветки, '#RRGGBB'. */
  accent?: string;
  accentMode?: HookAccent;
  fontFamily?: string;
  box?: boolean | 'white' | 'black';
}): ReactElement {
  // Без затемнения по краям: третья карточка выглядывает и показывает, что ленту можно листать.
  return <div className="hook-cards" role="group" aria-label={t('editor.hook.style')}>
    {HOOK_STYLE_CHOICES.map(design => <button key={design} type="button" className="hook-card"
      aria-pressed={value === design} aria-label={ls(HOOK_STYLE_LABELS[design])}
      onClick={() => {
        if (value === design) return;
        telegram.hapticFeedback.selection();
        onChange(design);
      }}>
      <span className="hook-card-sample" aria-hidden="true">
        <HookOverlay text={t('editor.hookSample')} position="bottom" subtitlesEnabled={false} design={design}
          accent={accent} accentMode={accentMode} fontFamily={fontFamily} box={box} thumbnail />
      </span>
      <span className="hook-card-name">{ls(HOOK_STYLE_LABELS[design])}<span aria-hidden="true">{value === design ? '✓' : ''}</span></span>
    </button>)}
  </div>;
}
